import { PartAnimatedState, PartState } from '../types';
import { buzzingState } from './buzzing';
import { curiousState } from './curious';
import { disappointedState } from './disappointed';
import { excitedState } from './excited';
import { facingLeftState } from './facing-left';
import { facingRightState } from './facing-right';
import { flyingLeftState } from './flying-left';
import { flyingRightState } from './flying-right';
import { lookingRightState } from './looking-right';
import { pointingLeftState } from './pointing-left';
import { pointingRightState } from './pointing-right';
import { searchingState } from './searching';
import { straightOnState } from './straight-on';
import { thinkingState } from './thinking';
import { wavingState } from './waving';

// Re-export bored SVG component
export { BoredSVG } from './bored';

// Combined state parts for part-based animation
export const STATE_PARTS: Record<PartAnimatedState, PartState> = {
	curious: curiousState,
	thinking: thinkingState,
	disappointed: disappointedState,
	excited: excitedState,
	searching: searchingState,
	buzzing: buzzingState,
	straightOn: straightOnState,
	lookingRight: lookingRightState,
	facingRight: facingRightState,
	facingLeft: facingLeftState,
	flyingRight: flyingRightState,
	flyingLeft: flyingLeftState,
	waving: wavingState,
	pointingRight: pointingRightState,
	pointingLeft: pointingLeftState,
};
